<template>
    <div class="uk-section-xsmall uk-section-default uk-box-shadow-small" uk-sticky="show-on-up: true; animation: uk-aimation-slide-top;" v-if="isLogin">
        <div class="uk-container uk-container-expand">
            <nav class="uk-navbar-container uk-navbar-transparent" uk-navbar>
                <div class="uk-navbar-left"><a href="#offcanvas-left" uk-icon="icon: list" uk-toggle></a></div>
                <div class="uk-navbar-center">
                    <RouterLink to="/">
                        <img :src="'images/site_logo_2.png'" alt="SAVE PIC" width="142">
                    </RouterLink>
                    <div  v-if="newChat" class="new_chat"><span uk-icon="icon: mail; ratio: 1.3"></span></div>
                </div>
            </nav>
        </div>

        <div id="offcanvas-left" uk-offcanvas="overlay: true">
            <div class="uk-offcanvas-bar" >
                <button class="uk-offcanvas-close" type="button" uk-close></button>
                <div class="uk-section">
                    <ul class="uk-nav uk-nav-default">
                        <li>
                            <RouterLink to="/invite">
                                User invitation
                            </RouterLink>
                        </li>
                        <li>
                            <RouterLink to="/profile">
                                Settings
                            </RouterLink>
                        </li>
                        <li>
                            <a href="#" @click="logout">Logout</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    computed: {
        isLogin () {
            return this.$store.getters['auth/check']
        },
        username () {
            return this.$store.getters['auth/username']
        },
        ...mapState({
            apiStatus: state => state.auth.apiStatus
        }),
        ...mapGetters({
            isLogin: 'auth/check'
        }),
        newChat() {
            return this.$store.state.message.newChat
        }
    },
    methods: {
        async logout () {
            await this.$store.dispatch('auth/logout')
            location.href='/login';

            // if (this.apiStatus) {
            //     this.$router.push('/login')
            // }
        }
    },
    mounted() {
        const store = this.$store
        // 画面がアクティブになったらチャットお知らせを消す。faviconのメッセージ数を消す。
        window.addEventListener('focus', function() {
            window.setTimeout(function() {
                // チャットお知らせの設定
                store.state.message.newChat = null
                // faviconのメッセージ数の設定
                store.commit('message/returnFavicon', null)
                store.state.message.unreadChatNum = 0
            }, 3000)
        });
    }
}
</script>
